<template>
  <div>
    <el-dialog
      :title="title"
      v-if="dialogVisible"
      :show-close="true"
      :visible.sync="dialogVisible"
      :before-close="close"
      v-el-dialog-drag
      width="950px"
      :close-on-click-modal="false"
    >
      <vxe-grid
        ref="expenseTable"
        show-overflow
        highlight-hover-row
        :data.sync="tableData"
        :columns="tableColumns"
        :toolbar-config="show ? tableToolbar : false"
        :edit-rules="validRules"
        :loading="loading"
        row-key
        height="400"
        size="small"
        auto-resize
        resizable
        border
        :edit-config="{ enabled: show, trigger: 'click', mode: 'row' }"
      >
        <template v-slot:toolbar_form>
          <slot name="header">
            <div class="side-frame-warning">
              <span class="side-frame-text">费用明细</span>
              <el-divider direction="vertical"></el-divider>
              <el-button
                type="primary"
                icon="el-icon-plus"
                size="small"
                @click="add()"
                >{{ $l('INDEX.product_dialog_btn_add') || '添加' }}</el-button
              >
              <el-button
                type="danger"
                class="mr-4"
                icon="el-icon-delete"
                size="small"
                @click="removeCheckbox()"
                >{{ $l('INDEX.btn_tips_del') || '删除' }}</el-button
              >
              <el-radio-group v-model="bookType" @change="radioChange">
                <el-radio label="A">收入费用</el-radio>
                <el-radio label="B">支出费用</el-radio>
              </el-radio-group>
            </div>
          </slot>
        </template>
      </vxe-grid>
      <span slot="footer" class="dialog-footer" v-if="show">
        <el-button size="small" @click="close">取消</el-button>
        <el-button size="small" type="primary" @click="saveFee">保存</el-button>
      </span>
      <span
        slot="footer"
        class="dialog-footer mt-3 d-flex justify-content-center"
        v-if="!show"
      >
        <el-button size="medium" type="primary" @click="close">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    soBillDetailCodeList: {
      type: Array,
      default: () => null,
    },
    soBillCodeList: {
      type: Array,
      default: () => null,
    },
    soBillDetailCode: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      tableData: [],
      bookType: 'A',
      loading: false,
      validRules: {
        price: [
          {
            type: 'number',
            required: true,
            trigger: 'blur',
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message: '费用须大于0',
          },
        ],
        feeName: [{ required: true, message: '费用类型必须填写' }],
      },
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: [
        {
          field: 'seq',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'checkbox',
        },
        {
          field: 'feeName',
          headerAlign: 'center',
          align: 'center',
          minWidth: 150,
          title: '费用类型',
          editRender: {
            name: 'dict-select',
            props: {
              default: true,
              clearable: true,
              filterable: true,
              placeholder: '请选择费用类型',
              body: { type: 'feeName' },
            },
          },
        },
        {
          field: 'price',
          headerAlign: 'center',
          align: 'center',
          minWidth: 100,
          title: '费用',
          editRender: {
            name: 'ElInputNumber',
            props: {
              controlsPosition: 'right',
              style: 'width:100%',
              min: 0,
              step: 0.01,
              precision: 2,
            },
            placeholder: '请输入费用',
            immediate: true,
          },
        },
      ],
    }
  },
  created() {
    this.getFeeList()
  },
  methods: {
    async add(row) {
      const $table = this.$refs.expenseTable
      const { row: newRow } = await $table.insertAt({}, row, newRow)
    },
    getTableData() {
      const { tableData } = this.$refs.expenseTable.getTableData()
      return tableData.map((row) => {
        return {
          price: row.price,
          feeNameText: row.feeNameText,
          feeName: row.feeName,
        }
      })
    },

    async validate() {
      const result = await this.$refs.expenseTable.validate(true)
      return !result
    },

    removeCheckbox() {
      this.$refs.expenseTable.removeCheckboxRow()
    },
    getFeeList() {
      if (this.soBillDetailCode) {
        this.loading = true
        this.$api
          .finSoStatementFeeListApi({
            soBillDetailCode: this.soBillDetailCode,
            bookType: this.show ? this.bookType : this.type,
          })
          .then((res) => {
            this.loading = false
            this.tableData = res.body.data
          })
          .catch(() => {
            this.loading = false
          })
      }
    },
    close() {
      this.$emit('close')
    },
    saveFee() {
      const data = this.getTableData()
      this.validate().then(() => {
        this.loading = true
        this.$api
          .finSoStatementFeeSaveApi({
            bookType: this.bookType,
            soBillDetailCodeList: this.soBillDetailCodeList,
            soBillDetailCode: this.soBillDetailCode,
            soBillCodeList: this.soBillCodeList,
            detailList: data,
          })
          .then((res) => {
            this.loading = false
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
            })
          })
          .catch(() => {
            this.loading = false
          })
      })
    },
    radioChange() {
      this.tableData = []
      this.getFeeList()
    },
  },
}
</script>
